import { MessageBox } from 'element-ui'

const confirmUtil = {}

confirmUtil.confirm = (message, callback, confirm, cancel) => {
  MessageBox.confirm(message, '温馨提示', {
    closeOnClickModal: false,
    closeOnPressEscape: false,
    dangerouslyUseHTMLString: true,
    confirmButtonText: confirm || '确定',
    cancelButtonText: cancel || '取消',
    type: 'warning',
    beforeClose: (action, instance, done) => {
      done()
      if (action === 'confirm') {
        callback()
      }
    }
  }).then(action => {

  }).catch(() => {

  })
}

export default confirmUtil
